<template>
  <Page :title="$t('contacts.title')" :meta="$t('contacts.meta')">
    <div class="map-header">
      <div>
        <span class="marker d-block">{{ $t('contacts.general.title') }}</span>
        <ul class="map-list split-list">
          <li>{{ $t('contacts.name') }}</li>
          <li><span class="icon-location pre-line" />&nbsp;{{ $t('contacts.address') }}</li>
          <li>
            <span class="icon-envelope2 pre-line" />&nbsp;<a :href="`mailto:${$t('contacts.email')}`">{{ $t('contacts.email') }}</a>
          </li>
          <li><span class="icon-phone pre-line" />&nbsp;{{ $t('contacts.phone') }}</li>
          <li>
            <span class="pre-line">{{ $t('contacts.general.regNumberTitle') }}:</span>
            {{ $t('contacts.general.regNumber') }}
          </li>
          <li>
            <span class="pre-line">{{ $t('contacts.general.IBANTitle') }}:</span>
            {{ $t('contacts.general.IBAN') }}
          </li>
        </ul>
      </div>

      <div v-if="$t('contacts.social')">
        <span class="marker d-block">{{ $t('contacts.social.title') }}</span>
        <ul class="map-list list-horisontal mt-1">
          <li class="float-start me-3" v-for="item in $tm('contacts.social.items')" :key="item.url">
            <a class="icon-lg pre-line" :class="`icon-${item.icon}`" :href="item.url" />
          </li>
        </ul>
      </div>

    </div>
    <iframe :src="mapsUrl" height="481" />
  </Page>
</template>

<script>
import Page from './Page';

export default {
  props: ['id'],
  components: {
    Page,
  },
  data: () => ({
    mapsUrl: import.meta.env.VITE_MAPS_URL,
  }),
};
</script>

<style lang="scss" scoped>
  iframe {
    width: 100%;
    border: 0;
  }

  .claim-email {
    display: flex;
  }
</style>
